import { render, staticRenderFns } from "./CollapseButton.vue?vue&type=template&id=d8997ef0&scoped=true&"
import script from "./CollapseButton.vue?vue&type=script&lang=js&"
export * from "./CollapseButton.vue?vue&type=script&lang=js&"
import style0 from "./CollapseButton.vue?vue&type=style&index=0&id=d8997ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8997ef0",
  null
  
)

export default component.exports